<template>
  <v-system-bar
    v-if="model"
    app
    color="#262626"
    class="px-4"
    dark
    height="58"
  >
    <!-- <a
      class="d-flex align-center"
      href="https://vuetifyjs.com/?ref=vtyd-pro-demo-system-bar"
      target="_blank"
    >
      <v-img
        alt="Vuetify Logo"
        class="mr-2"
        contain
        src="https://cdn.vuetifyjs.com/images/logos/vuetify-logo-dark.png"
        width="32"
      />

      <v-img
        alt="Vuetify Name"
        class="hidden-xs-only"
        contain
        width="96"
        src="https://cdn.vuetifyjs.com/images/logos/vuetify-name-dark.png"
      />
    </a> -->
    <v-spacer />

<!--    <v-btn-->
<!--      :to="{name: 'Token'}"-->
<!--      class="text-capitalize subtitle-2 hidden-xs-only"-->
<!--      color="primary"-->
<!--      min-width="112"-->
<!--      text-->
<!--      outlined-->
<!--    >-->
<!--      HEQ/USD: ${{ Number(currentTokenPrice).toFixed(2) }}-->
<!--    </v-btn>-->

<!--    <v-divider-->
<!--      class="ml-3 mr-3"-->
<!--      vertical-->
<!--    />-->

<!--    <v-btn-->
<!--      :to="{name: 'Mobile Download'}"-->
<!--      class="text-capitalize subtitle-2 hidden-xs-only"-->
<!--      color="primary"-->
<!--      min-width="112"-->
<!--    >-->
<!--      Get The App-->
<!--    </v-btn>-->

<!--    <v-divider-->
<!--      class="ml-3 mr-3"-->
<!--      vertical-->
<!--    />-->
<!--    <v-btn-->
<!--      class="text-capitalize subtitle-2 hidden-xs-only"-->
<!--      color="success"-->
<!--      min-width="112"-->
<!--      @click="compareLoans"-->
<!--    >-->
<!--      Loan Comparison-->
<!--    </v-btn>-->

    <!--    <v-btn-->
    <!--      class="text-capitalize grey&#45;&#45;text mr-n2 mr-sm-n1"-->
    <!--      small-->
    <!--      text-->
    <!--      @click="model = false"-->
    <!--    >-->
    <!--      <v-icon-->
    <!--        color="white"-->
    <!--        :left="$vuetify.breakpoint.smAndUp"-->
    <!--      >-->
    <!--        mdi-close-->
    <!--      </v-icon>-->

    <!--      <span class="hidden-xs-only">-->
    <!--        Hide-->
    <!--      </span>-->
    <!--    </v-btn>-->
  </v-system-bar>
</template>

<script>
  export default {
    name: 'HomeSystemBar',
    data: () => ({
      model: true,
      currentTokenPrice: 1.33,
    }),
    methods: {
      compareLoans () {
        this.$router.push({ name: 'Loan Comparison' })
      },
      numberWithCommas (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      },
    },
  }
</script>
